function requireEnv(key: string): string {
  const value = import.meta.env[key] as string | undefined;
  if (!value) {
    throw new Error(`Missing required environment variable: ${key}`);
  }
  return value;
}

function optionalEnv(key: string, fallback: string): string {
  return (import.meta.env[key] as string | undefined) ?? fallback;
}

const apiUrl = requireEnv('VITE_API_URL');

export const config = Object.freeze({
  apiUrl,
  // transitApiUrl was removed with the tickets app: it was the only consumer, and it now lives in
  // the wayq-transit repo pointing at that backend directly. Nothing in this workspace calls
  // ticketing, so re-adding a transit URL here would be re-creating the cross-repo coupling the
  // move existed to remove.
  environment: optionalEnv('VITE_ENVIRONMENT', 'dev'),
  // Which product this web app is (admin_web / work_web / tickets_web). Sent as
  // the X-Client-Product header so the backend attributes requests (metrics,
  // logs, origin_product). Must match the backend product vocabulary; falls
  // back to 'unknown' if the build didn't inject it.
  clientProduct: optionalEnv('VITE_CLIENT_PRODUCT', 'unknown'),
  useEmulators: import.meta.env.VITE_USE_EMULATORS === 'true',
  authEmulatorUrl: optionalEnv('VITE_AUTH_EMULATOR_URL', 'http://localhost:9399'),
  firebase: Object.freeze({
    projectId: requireEnv('VITE_FIREBASE_PROJECT_ID'),
    apiKey: requireEnv('VITE_FIREBASE_API_KEY'),
    authDomain: requireEnv('VITE_FIREBASE_AUTH_DOMAIN'),
    storageBucket: optionalEnv('VITE_FIREBASE_STORAGE_BUCKET', ''),
    appId: optionalEnv('VITE_FIREBASE_APP_ID', ''),
  }),
  appCheck: Object.freeze({
    enabled: import.meta.env.VITE_APP_CHECK_ENABLED === 'true',
    siteKey: optionalEnv('VITE_RECAPTCHA_ENTERPRISE_SITE_KEY', ''),
  }),
});

export type Config = typeof config;
